import React, { useContext, useState } from "react";
import EventContext from "../event/eventContext";
import { withRouter } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

const Create = (props) => {
	const eventContext = useContext(EventContext);
	const [state, setState] = useState("");
	const [showPotrdi, setShowPotrdi] = useState(false);
	const [btnDis, setBtnDis] = useState(false);
	const { addEvent, circleFunction, setCircle, circle } = eventContext;
	const [newEvent, setNewEvent] = useState({
		lessonInstructionsOne: "Preglej sklope in sledi navodilom",
		lessonInstructionsTwo:
			"V zvezek si delaj zapiske, tako da upoštevaš splošna navodila",
		lessonHomeworkOne: "Za to uro ni zahtevana nobena dodatna naloga",
	});

	const {
		lesson,
		ytLinkInfo,
		lessonClassName,
		lessonDate,
		lessonTitle,
		ytLink,
		lessonInstructionsOne,
		lessonInstructionsTwo,
		lessonHomeworkOne,
		lessonHomeworkTwo,
		lessonHomeworkThree,
		lessonPartOneInstructions,
		lessonPartTwoInstructions,
		lessonPartThreeInstructions,
		lessonPartFourInstructions,

		lessonPartOneSrc,
		lessonPartTwoSrc,
		lessonPartThreeSrc,
		lessonPartFourSrc,

		pdfSrc,
		pdfInfo,
		lessonLinkOne,
		lessonLinkTwo,
		lessonLinkThree,
		lessonLinkFour,
		lessonLinkFourInfo,
		lessonLinkThreeInfo,
		lessonLinkTwoInfo,
		lessonLinkOneInfo,
	} = newEvent;

	const onSubmit = (e) => {
		e.preventDefault();
		addEvent(newEvent);
		setShowPotrdi(true);
		setBtnDis(true);
	};

	return (
		<div>
			<div className='create-title'>DODAJ UČNO URO</div>
			<form className='form-create' onSubmit={(e) => onSubmit(e)}>
				<section className='create-form-container'>
					<h1 className='form-title'>Splošni podatki</h1>
					<div class='colors'>
						<span
							className={newEvent.isBlue ? "circle-blue-border" : "circle-blue"}
							onClick={() =>
								setNewEvent({ isPurple: false, isGreen: false, isBlue: true })
							}
						></span>
						<span
							className={
								newEvent.isGreen ? "circle-green-border" : "circle-green"
							}
							onClick={() =>
								setNewEvent({ isBlue: false, isPurple: false, isGreen: true })
							}
						></span>
						<span
							className={
								newEvent.isPurple ? "circle-purple-border" : "circle-purple"
							}
							onClick={() =>
								setNewEvent({ isGreen: false, isBlue: false, isPurple: true })
							}
						></span>
					</div>
					<label for='vrsta' className='form-label'>
						Izberi razred
					</label>
					<select
						className='form-select'
						value={lessonClassName}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonClassName: e.target.value,
								id: uuidv4(),
							});
						}}
					>
						<option value='0. razred'>Izberi razred</option>
						<option value='1.a'>1.a razred</option>
						<option value='1.b'>1.b razred</option>
						<option value='2.a'>2.a razred</option>
						<option value='2.b'>2.b razred</option>
						<option value='3.a'>3.a razred</option>
						<option value='3.b'>3.b razred</option>
						<option value='4.a'>4.a razred</option>
						<option value='4.b'>4.b razred</option>
						<option value='5.a'>5.a razred</option>
						<option value='5.b'>5.b razred</option>
						<option value='6.a'>6.a razred</option>
						<option value='6.b'>6.b razred</option>
						<option value='6.ddp'>6.DDP</option>
						<option value='7.a'>7.a razred</option>
						<option value='7.b'>7.b razred</option>
						<option value='7.ddp'>7.DDP</option>
						<option value='8-kerstein'>8. razred - Kerstein</option>
						<option value='8-ursic'>8. razred - Uršič</option>
						<option value='8-stanko'>8. razred - Stanko</option>
						<option value='8.ddp'>8.DDP</option>
						<option value='9-kerstein'>9. razred - Kerstein</option>
						<option value='9-ursic'>9. razred - Uršič</option>
						<option value='9-stanko'>9. razred - Stanko</option>
						<option value='9.ddp'>9.DDP</option>
					</select>
					<label for='mesto' className='form-label'>
						Številka ure
					</label>
					<select
						className='form-select'
						value={lesson}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lesson: e.target.value });
						}}
					>
						<option value='0.'>Izberi številko ure</option>
						<option value='1.'>1.</option>
						<option value='2.'>2.</option>
						<option value='3.'>3.</option>
						<option value='4.'>4.</option>
						<option value='5.'>5.</option>
						<option value='6.'>6.</option>
						<option value='7.'>7.</option>
						<option value='8.'>8.</option>
						<option value='9.'>9.</option>
						<option value='10.'>10.</option>
						<option value='11.'>11.</option>
						<option value='12.'>12.</option>
						<option value='13.'>13.</option>
						<option value='14.'>14.</option>
						<option value='15.'>15.</option>
						<option value='16.'>16.</option>
						<option value='17.'>17.</option>
						<option value='18.'>18.</option>
						<option value='19.'>19.</option>
						<option value='20.'>20.</option>
						<option value='21.'>21.</option>
						<option value='22.'>22.</option>
						<option value='23.'>23.</option>
						<option value='24.'>24.</option>
						<option value='25.'>25.</option>
						<option value='26.'>26.</option>
						<option value='27.'>27.</option>
						<option value='28.'>28.</option>
						<option value='29.'>29.</option>
						<option value='30.'>30.</option>
						<option value='31.'>31.</option>
						<option value='32.'>32.</option>
						<option value='33.'>33.</option>
						<option value='34.'>34.</option>
						<option value='35.'>35.</option>
					</select>

					<label for='mesto' className='form-label'>
						Izberi datum
					</label>
					<input
						type='date'
						className='form-input'
						value={lessonDate}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lessonDate: e.target.value });
						}}
					/>
					<label for='venue' className='form-label'>
						Naslov učne ure
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonTitle}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lessonTitle: e.target.value });
						}}
					/>
				</section>
				<section className='create-form-container'>
					<h1 className='form-title'>Navodila in naloge</h1>
					<label for='vrsta' className='form-label'>
						1. navodilo
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonInstructionsOne}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonInstructionsOne: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						2. navodilo
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonInstructionsTwo}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonInstructionsTwo: e.target.value,
							});
						}}
					/>
					<br></br>
					<label for='vrsta' className='form-label'>
						1. naloga
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonHomeworkOne}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lessonHomeworkOne: e.target.value });
						}}
					/>
					<label for='vrsta' className='form-label'>
						2. naloga
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonHomeworkTwo}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lessonHomeworkTwo: e.target.value });
						}}
					/>
					<label for='vrsta' className='form-label'>
						3. naloga
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonHomeworkThree}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lessonHomeworkThree: e.target.value });
						}}
					/>
				</section>
				<section className='create-form-container'>
					<h1 className='form-title-small'>Youtube video</h1>
					<label for='vrsta' className='form-label'>
						Navodila sklopa
					</label>
					<input
						type='text'
						className='form-input'
						value={ytLinkInfo}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								ytLinkInfo: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						Vir
					</label>
					<input
						type='text'
						className='form-input'
						value={ytLink}
						onChange={(e) => {
							setNewEvent({ ...newEvent, ytLink: e.target.value });
						}}
					/>
					<h1 className='form-title-small'>PDF</h1>
					<label for='vrsta' className='form-label'>
						Navodila sklopa
					</label>
					<input
						type='text'
						className='form-input'
						value={pdfInfo}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								pdfInfo: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						Vir
					</label>
					<input
						type='text'
						className='form-input'
						value={pdfSrc}
						onChange={(e) => {
							setNewEvent({ ...newEvent, pdfSrc: e.target.value });
						}}
					/>
					<h1 className='form-title-small'>POVEZAVE</h1>
					<label for='vrsta' className='form-label'>
						Opis 1. povezave
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonLinkOneInfo}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonLinkOneInfo: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						1. povezava
					</label>

					<input
						type='text'
						className='form-input'
						value={lessonLinkOne}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonLinkOne: e.target.value,
							});
						}}
					/>
					<br></br>
					<br></br>
					<label for='vrsta' className='form-label'>
						Opis 2. povezave
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonLinkTwoInfo}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonLinkTwoInfo: e.target.value,
							});
						}}
					/>

					<label for='vrsta' className='form-label'>
						2. povezava
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonLinkTwo}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonLinkTwo: e.target.value,
							});
						}}
					/>
					<br></br>
					<br></br>
					<label for='vrsta' className='form-label'>
						Opis 3. povezave
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonLinkThreeInfo}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonLinkThreeInfo: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						3. povezava
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonLinkThree}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonLinkThree: e.target.value,
							});
						}}
					/>
					<br></br>
					<br></br>
					<label for='vrsta' className='form-label'>
						Opis 4. povezave
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonLinkFourInfo}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonLinkFourInfo: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						4. povezava
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonLinkFour}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonLinkFour: e.target.value,
							});
						}}
					/>

					<h1 className='form-title-small'>1. sklop</h1>
					<label for='vrsta' className='form-label'>
						Navodila sklopa
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonPartOneInstructions}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonPartOneInstructions: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						Vir (google url)
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonPartOneSrc}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lessonPartOneSrc: e.target.value });
						}}
					/>

					<h1 className='form-title-small'>2. sklop</h1>
					<label for='vrsta' className='form-label'>
						Navodila sklopa
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonPartTwoInstructions}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonPartTwoInstructions: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						Vir (google url)
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonPartTwoSrc}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lessonPartTwoSrc: e.target.value });
						}}
					/>

					<h1 className='form-title-small'>3. sklop</h1>
					<label for='vrsta' className='form-label'>
						Navodila sklopa
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonPartThreeInstructions}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonPartThreeInstructions: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						Vir (google url)
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonPartThreeSrc}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lessonPartThreeSrc: e.target.value });
						}}
					/>
					{""}
					{""}
					<h1 className='form-title-small'>4. sklop</h1>
					<label for='vrsta' className='form-label'>
						Navodila sklopa
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonPartFourInstructions}
						onChange={(e) => {
							setNewEvent({
								...newEvent,
								lessonPartFourInstructions: e.target.value,
							});
						}}
					/>
					<label for='vrsta' className='form-label'>
						Vir (google url)
					</label>
					<input
						type='text'
						className='form-input'
						value={lessonPartFourSrc}
						onChange={(e) => {
							setNewEvent({ ...newEvent, lessonPartFourSrc: e.target.value });
						}}
					/>

					{btnDis ? (
						<button className='form-button' disabled>
							Potrdi
						</button>
					) : (
						<button className='form-button'>Potrdi</button>
					)}
					{showPotrdi ? (
						<h1 style={{ fontSize: "3rem", marginTop: "3rem" }}>
							Uspešno oddana vaja
						</h1>
					) : (
						false
					)}
				</section>
			</form>
		</div>
	);
};

export default Create;
